<template>
  <div class="curve-item-wrapper">
    <div v-if="curveDirection==='0'" class="curve-item" >
      <svg class="curve-item-svg" xmlns="http://www.w3.org/2000/svg">
        <!-- 黄色投影 -->
        <path d="M230 100 L71 52 A115 115 0 0 0 71 148" :fill="projectionFillColor" fill-opacity="0.7" stroke="none"/>
        <!-- 屏幕曲面 -->
        <path d="M200 100 L73 42 A150 150 0 0 0 73 158 Z" fill="none" :stroke="screenDashedColor" stroke-opacity="0.7" stroke-dasharray="4,2" stroke-width="1.5"/>
        <path d="M73 42 A150 150 0 0 0 73 158" fill="none" :stroke="screenLineColor" stroke-width="1.5"/>
        <!-- 水平虚线 -->
        <line x1="62" y1="100" x2="200" y2="100" :stroke="dashLineColor" stroke-dasharray="2,2" stroke-width="0.25"/>

        <!-- 投影仪框（水平曲面） -->
        <path v-if="curveShape==='1'" d="M233 98 L236 98 L236 89 L261 89 L261 111 L236 111 L236 103 L233 103 Z" fill="none" :stroke="dashLineColor" stroke-width="1.8"/>
        <!-- 投影仪框（垂直曲面） -->
        <path v-if="curveShape==='0'" d="M233 98 L236 98 L236 95 L260 95 L260 106 L236 106 L236 103 L233 103 Z" fill="none" :stroke="dashLineColor" stroke-width="1.8"/>

        <!-- 垂直虚线 -->
        <line v-if="curveSelect==='2' || curveSelect2==='2' || curveSelect==='4' || curveSelect2==='4'" x1="74.5" y1="42" x2="74.5" y2="158" :stroke="dashLineColor" stroke-dasharray="2,2" stroke-width="0.25"/>
        <!-- 深度箭头标记 -->
        <path v-if="curveSelect==='2' || curveSelect2==='2'" d="M62 100 L66 96 L66 104 Z" :fill="markerColor"/>
        <path v-if="curveSelect==='2' || curveSelect2==='2'" d="M75 100 L71 96 L71 104 Z" :fill="markerColor"/>
        <line v-if="curveSelect==='2' || curveSelect2==='2'" x1="66" y1="100" x2="71" y2="100" :stroke="markerColor" stroke-width="2"/>
        <!-- <line v-if="curveSelect==='2' || curveSelect2==='2'" x1="74.5" y1="36" x2="74.5" y2="166" :stroke="dashLineColor" stroke-dasharray="2,2" stroke-width="0.25"/> -->
        <!-- 弧度标记 -->
        <path v-if="curveSelect==='1' || curveSelect2==='1'" d="M73 42 A150 150 0 0 0 73 158" fill="none" :stroke="markerColor" stroke-width="4"/>
        <!-- 角度标记 -->
        <path v-if="curveSelect==='0' || curveSelect2==='0'" d="M200 100 L171 87 A25 25 0 0 0 171 113 Z" :fill="angleFillColorTop" fill-opacity="0.7" :stroke="markerColor" stroke-width="3"/>

        <!-- 指示箭头（角度）从下往上 -->
        <path v-if="curveSelect2==='0'" d="M180 111 L174 116 L183 119 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='0'" x1="179" y1="115" x2="160" y2="167" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（弧度）从下往上 -->
        <path v-if="curveSelect2==='1'" d="M68 131 L77 130 L75 139 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='1'" x1="76" y1="135" x2="162" y2="167" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（深度）从下往上 -->
        <path v-if="curveSelect2==='2'" d="M69 107 L78 109 L71 116 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='2'" x1="72" y1="111" x2="160" y2="167" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（半径）从下往上 -->
        <path v-if="curveSelect2==='3'" d="M153 124 L150 132 L159 131 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='3'" x1="154" y1="130" x2="160" y2="167" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（宽 弦长）从下往上 -->
        <path v-if="curveSelect2==='4'" d="M77 120 L87 120 L80 129 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='4'" x1="78" y1="122" x2="160" y2="167" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>

        <!-- 指示箭头（角度）从上往下 -->
        <path v-if="curveSelect==='0'" d="M180 89 L174 84 L183 81 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='0'" x1="179" y1="85" x2="160" y2="31" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（弧度）从上往下 -->
        <path v-if="curveSelect==='1'" d="M68 69 L77 70 L75 61 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='1'" x1="76" y1="65" x2="162" y2="31" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（深度）从上往下 -->
        <path v-if="curveSelect==='2'" d="M69 93 L78 91 L71 84 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='2'" x1="72" y1="89" x2="160" y2="31" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（半径）从上往下 -->
        <path v-if="curveSelect==='3'" d="M153 76 L150 68 L159 69 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='3'" x1="154" y1="70" x2="160" y2="31" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（宽 弦长）从上往下 -->
        <path v-if="curveSelect==='4'" d="M77 80 L87 80 L80 71 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='4'" x1="78" y1="78" x2="160" y2="31" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
      </svg>
    </div>
    <div v-else class="curve-item" >
      <svg class="curve-item-svg" xmlns="http://www.w3.org/2000/svg">
        <!-- 黄色投影 -->
        <path d="M252 100 L175 64 A121 121 0 0 1 175 136" :fill="projectionFillColor" fill-opacity="0.7" stroke="none"/>
        <!-- 屏幕曲面 -->
        <path d="M40 100 L167 42 A138 138 0 0 1 167 158 Z" fill="none" :stroke="screenDashedColor" stroke-opacity="0.7" stroke-dasharray="4,2" stroke-width="1.5"/>
        <path d="M167 42 A138 138 0 0 1 167 158" fill="none" :stroke="screenLineColor" stroke-width="1.5"/>
        <!-- 水平虚线 -->
        <line x1="40" y1="100" x2="180" y2="100" :stroke="dashLineColor" stroke-dasharray="2,2" stroke-width="0.25"/>

        <!-- 投影仪框（水平曲面） -->
        <path v-if="curveShape==='1'" d="M254 98 L257 98 L257 89 L282 89 L282 111 L257 111 L257 103 L254 103 Z" fill="none" :stroke="dashLineColor" stroke-width="1.8"/>
        <!-- 投影仪框（垂直曲面） -->
        <path v-if="curveShape==='0'" d="M254 98 L257 98 L257 95 L282 95 L282 106 L257 106 L257 103 L254 103 Z" fill="none" :stroke="dashLineColor" stroke-width="1.8"/>

        <!-- 垂直虚线 -->
        <line v-if="curveSelect==='2' || curveSelect2==='2' || curveSelect==='4' || curveSelect2==='4'" x1="166.5" y1="42" x2="166.5" y2="158" :stroke="dashLineColor" stroke-dasharray="2,2" stroke-width="0.25"/>
        <!-- 深度箭头标记 -->
        <path v-if="curveSelect==='2' || curveSelect2==='2'" d="M166 100 L170 96 L170 104 Z" :fill="markerColor"/>
        <path v-if="curveSelect==='2' || curveSelect2==='2'" d="M180 100 L176 96 L176 104 Z" :fill="markerColor"/>
        <line v-if="curveSelect==='2' || curveSelect2==='2'" x1="170" y1="100" x2="176" y2="100" :stroke="markerColor" stroke-width="2"/>
        <!-- 弧度标记 -->
        <path v-if="curveSelect==='1' || curveSelect2==='1'" d="M167 42 A138 138 0 0 1 167 158" fill="none" :stroke="markerColor" stroke-width="4"/>
        <!-- 角度标记 -->
        <path v-if="curveSelect==='0' || curveSelect2==='0'" d="M42.5 100 L68 88 A25 25 0 0 1 68 112 Z" :fill="angleFillColorBottom" fill-opacity="0.7" :stroke="markerColor" stroke-width="3"/>

        <!-- 指示箭头（角度）从下往上 -->
        <path v-if="curveSelect2==='0'" d="M58 109 L65 115 L56 117 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='0'" x1="60" y1="115" x2="79" y2="168" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（弧度）从下往上 -->
        <path v-if="curveSelect2==='1'" d="M166 116 L175 115 L173 124 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='1'" x1="170" y1="119" x2="79" y2="168" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（深度）从下往上 -->
        <path v-if="curveSelect2==='2'" d="M165 101 L163 109 L156 103 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='2'" x1="161" y1="105" x2="79" y2="168" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（半径）从下往上 -->
        <path v-if="curveSelect2==='3'" d="M111 134 L110 143 L102 137 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='3'" x1="108" y1="138" x2="79" y2="168" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（宽 弦长）从下往上 -->
        <path v-if="curveSelect2==='4'" d="M166 121 L162 130 L155 122 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect2==='4'" x1="162" y1="124" x2="79" y2="168" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>

        <!-- 指示箭头（角度）从上往下 -->
        <path v-if="curveSelect==='0'" d="M58 91 L65 85 L56 83 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='0'" x1="60" y1="85" x2="79" y2="30" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（弧度）从上往下 -->
        <path v-if="curveSelect==='1'" d="M166 84 L175 85 L173 76 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='1'" x1="170" y1="81" x2="79" y2="30" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（深度）从上往下 -->
        <path v-if="curveSelect==='2'" d="M165 99 L163 91 L156 97 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='2'" x1="161" y1="95" x2="79" y2="30" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（半径）从上往下 -->
        <path v-if="curveSelect==='3'" d="M111 66 L110 57 L102 63 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='3'" x1="108" y1="62" x2="79" y2="30" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
        <!-- 指示箭头（宽 弦长）从上往下 -->
        <path v-if="curveSelect==='4'" d="M166 79 L162 70 L155 78 Z" :fill="arrowLineColor"/>
        <line v-if="curveSelect==='4'" x1="162" y1="76" x2="79" y2="30" :stroke="arrowLineColor" :stroke-width="arrowWidth"/>
      </svg>
    </div>
  </div>
</template>

<script>
// import { mapState } from 'vuex'
export default {
  name: 'CurveConditionImage',
  props: {
    curveShape: {
      type: String,
      default: '1'
    },
    curveDirection: {
      type: String,
      default: '0'
    },
    curveSelect: {
      type: String,
      default: '0'
    },
    curveSelect2: {
      type: String,
      default: '1'
    }
  },
  data () {
    return {
      arrowWidth: 2, // 带箭头直线宽度
      arrowLineColor: '#10218b', // 线条颜色
      projectionFillColor: '#ffff99', // 黄色投影填充
      screenDashedColor: '#656B84', // 屏幕曲面虚线
      screenLineColor: '#656B7E', // 屏幕曲面实线
      dashLineColor: '#000000', // 辅助虚线/投影仪框
      markerColor: '#525977', // 深度/弧度/角度标记
      angleFillColorTop: '#B4BAA8', // 角度标记填充（方向0）
      angleFillColorBottom: '#9095B5' // 角度标记填充（方向1）
    }
  },
  mounted () {
    // console.log('arrowLineColor:', this.arrowLineColor)
  },
  computed: {
  //   ...mapState(['theme']),
  //   arrowLineColor () {
  //     return this.theme === 'dark' ? '#7aa2ff' : '#10218b'
  //   },
  //   projectionFillColor () {
  //     // return this.theme === 'dark' ? '#dce03a' : '#ffff99'
  //     return this.theme === 'dark' ? '#feffb3' : '#ffff99'
  //   },
  //   screenDashedColor () {
  //     return this.theme === 'dark' ? '#8a92ad' : '#656B84'
  //   },
  //   screenLineColor () {
  //     return this.theme === 'dark' ? '#9aa0c0' : '#656B7E'
  //   },
  //   dashLineColor () {
  //     return this.theme === 'dark' ? '#ffffff' : '#000000'
  //   },
  //   markerColor () {
  //     return this.theme === 'dark' ? '#b8c0e0' : '#525977'
  //   },
  //   angleFillColorTop () {
  //     return this.theme === 'dark' ? '#5a6078' : '#B4BAA8'
  //   },
  //   angleFillColorBottom () {
  //     return this.theme === 'dark' ? '#4a4f6b' : '#9095B5'
  //   }
  }
}
</script>

<style scoped>
.curve-item-wrapper {
  display: flex;
  justify-content: center;
}

.curve-item {
  position: relative;
  width: 322px;
  height: 200px;
}
.curve-item-svg {
  width: 322px;
  height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/curveConditionImage.vue